import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { BACKEND } from "../../config/configEnvs";
import { toast } from "react-toastify";
import {
  FaBan,
  FaCamera,
  FaCheck,
  FaExternalLinkAlt,
  FaEye,
  FaEyeSlash,
  FaFilePdf,
  FaGoogle,
  FaImage,
  FaLink,
  FaLock,
  FaLockOpen,
  FaPause,
  FaPlay,
  FaPlayCircle,
  FaPlus,
  FaSave,
  FaSpinner,
  FaTimes,
  FaTrash,
  FaTrashAlt,
  FaVideo,
} from "react-icons/fa";
import { useSelector } from "react-redux";
import Modal from "../ui/Modal";
import { Task, TaskAlt, UploadFile } from "@mui/icons-material";
import RegisterDeliverCard from "./RegisterDeliverCard";
import { SiGooglemeet } from "react-icons/si";
import Tooltip from "../ui/ToolTip";
import ActualizarFechaInicioProyecto from "../../utils/automateFuncions/ActualizarFechaInicioProyecto";
import GenerarCompraAgencia from "../../utils/automateFuncions/GenerarCompraAgencia";

const ItemRowTareaProyecto = ({
  task,
  successChildUpdate,
  userStatus,
  trabajadores,
  addRegisterTaskEvents,
  firstMeeting,
  clientName,
}) => {
  // Importante: Si se añaden nuevos campos al modelo "Task", no se verán automáticamente acá
  // Se formatea la task en el archivo "SeguimientoDetails.jsx" funcion > groupPhasesObjectivesTasks > línea 117
  // Ahí se deben colocar los cambpos que se desean pasar al child component (si, este mismo)

  const [isLoading, setIsLoading] = useState(false);

  const user = useSelector((state) => state.auth.user); // Usuario => IMPORTANTE!

  const [status, setStatus] = useState(task.status);
  const [initialStatus, setInitialStatus] = useState(task.status);

  const [responsible, setResponsible] = useState(task.responsible);
  const [initialResponsible, setInitialResponsible] = useState(
    task.responsible
  );

  const [startDate, setStartDate] = useState(task.startDate);
  const [initialStartDate, setInitialStartDate] = useState(task.startDate);

  const [limitDate, setLimitDate] = useState(task.limitDate);
  const [initialLimitDate, setInitialLimitDate] = useState(task.limitDate);

  const [deliverDate, setDeliverDate] = useState(task.deliverDate);
  //const [initialDeliverDate, setInitialDeliverDate] = useState(task.deliverDate)

  const [proofModal, setProofModal] = useState(false);

  const [watchMediaModal, setWatchMediaModal] = useState(false);

  const [taskMedia, setTaskMedia] = useState(
    task.proofMedia ? task.proofMedia : []
  );

  const [deliverHistorical, setDeliverHistorical] = useState(
    task.deliverHistorical ? task.deliverHistorical : []
  );

  const [lockedStatus, setLockedStatus] = useState(task.locked);
  const [initialLockedStatus, setInitialLockedStatus] = useState(task.locked);

  const [filesToUpload, setFilesToUpload] = useState([]);

  /// Links de evidencia
  const [links, setLinks] = useState([]);
  const [workerNotes, setWorkerNotes] = useState("");

  const handleLinkChange = (index, event) => {
    const newLinks = [...links];
    newLinks[index] = { link: event.target.value };
    setLinks(newLinks);
  };

  const addLinkField = () => {
    if (links.length < 5) {
      setLinks([...links, { link: "" }]);
    }
  };

  const removeLinkField = (index) => {
    const newLinks = links.filter((_, i) => i !== index);
    setLinks(newLinks);
  };

  // Archivos de evidencia
  const handleMediaUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `${BACKEND}/api/pruebasTareas`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.data && response.data.doc && response.data.doc.id) {
        return response.data.doc.id;
      } else {
        throw new Error("El ID del archivo no se encontró en la respuesta.");
      }
    } catch (error) {
      toast.error("Error subiendo un archivo: " + error);
    }
  };

  const handleDeleteMedia = async (id) => {
    try {
      const response = await axios.delete(`${BACKEND}/api/pruebasTareas/${id}`);
      successChildUpdate();
    } catch (error) {
      toast.error("Error eliminando un archivo: " + error);
    }
  };

  const updateStatus = async () => {
    if (status !== initialStatus) {
      const updateData = {
        status: status,
      };

      // Si el estado es "Pendiente" y el usuario es SuperAdmin
      if (
        (status === "Pendiente" && userStatus === "SuperAdmin") ||
        (status === "Declinado" && userStatus === "SuperAdmin")
      ) {
        updateData.deliverDate = null; // Establece deliverDate en null
        updateData.delivered = false; // Establece delivered en false
        setTaskMedia([]);
        setDeliverDate(null);

        if (taskMedia && taskMedia.length > 0) {
          for (const media of taskMedia) {
            await handleDeleteMedia(media.id); // Asume que media tiene un campo id
          }
        }
      }
      try {
        await axios.put(
          `${BACKEND}/api/tareasProyectos/${task.id}`,
          updateData
        );

        successChildUpdate();
        setInitialStatus(status);
      } catch (error) {
        toast.error("Error actualizando el estado: " + error);
      }
    }
  };

  const updateStatusFromChild = (status) => {
    setStatus(status);
  };

  const updateDeliverStatus = async (e, deliverId) => {
    try {
      // Obtener la tarea actual
      const { data: taskData } = await axios.get(
        `${BACKEND}/api/tareasProyectos/${task.id}`
      );

      // Encontrar el índice del registro a actualizar dentro del deliverHistorical
      const updatedDeliverHistorical = taskData.deliverHistorical.map(
        (item) => {
          if (item.id === deliverId) {
            // Actualizar solo el campo que necesitas cambiar, por ejemplo `deliverStatus`
            return {
              ...item, // Mantener los demás campos intactos
              deliverStatus: e.target.value, // Actualizamos el estatus con el valor seleccionado
              reviewedBy: user.id,
            };
          }
          return item; // Devolver los demás elementos sin modificar
        }
      );

      // Enviar la actualización al backend
      const response = await axios.put(
        `${BACKEND}/api/tareasProyectos/${task.id}`,
        {
          deliverHistorical: updatedDeliverHistorical,
        }
      );

      toast.success("Estado de entrega actualizado correctamente");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado de entrega");
    }
  };

  const updateResponsible = async () => {
    // Actualizar el responsable de la tarea
    if (responsible !== initialResponsible) {
      try {
        const responsibleId = responsible ? responsible.id : null; // Maneja el caso cuando `responsible` es null
        const response = await axios.put(
          `${BACKEND}/api/tareasProyectos/${task.id}`,
          {
            responsible: responsibleId,
          }
        );
        successChildUpdate();
        setInitialResponsible(responsible); // Actualiza el estado inicial para evitar futuros cambios innecesarios
      } catch (error) {
        console.log(error);
        toast.error("Error actualizando al responsable de la tarea: " + error);
      }
    }
  };

  const updateStartDate = async () => {
    if (startDate !== initialStartDate) {
      try {
        await axios.put(`${BACKEND}/api/tareasProyectos/${task.id}`, {
          startDate: new Date(startDate).toISOString(),
        });
        successChildUpdate();
        setInitialStartDate(startDate);
      } catch (error) {
        toast.error("Error actualizando la fecha de inicio: " + error);
      }
    }
  };

  const updateLimitDate = async () => {
    if (limitDate !== initialLimitDate) {
      try {
        await axios.put(`${BACKEND}/api/tareasProyectos/${task.id}`, {
          limitDate: new Date(limitDate).toISOString(),
        });
        successChildUpdate();
        setInitialLimitDate(limitDate);
      } catch (error) {
        toast.error("Error actualizando la fecha límite: " + error);
      }
    }
  };

  const updateLockRow = async (newLockedStatus) => {
    // Actualizar el bloqueo de la tarea => Solo admin
    if (newLockedStatus !== initialLockedStatus) {
      try {
        await axios.put(`${BACKEND}/api/tareasProyectos/${task.id}`, {
          locked: newLockedStatus,
        });
        toast.success(
          `Tarea ${
            newLockedStatus ? "bloqueada" : "desbloqueada"
          } correctamente`
        );
        successChildUpdate();
        setInitialLockedStatus(newLockedStatus);
        setLockedStatus(newLockedStatus); // Actualiza el estado local
      } catch (error) {
        toast.error("Error actualizando el estado de bloqueo: " + error);
      }
    }
  };

  useEffect(() => {
    updateStatus();
  }, [status]);

  useEffect(() => {
    updateResponsible();
  }, [responsible]);

  useEffect(() => {
    updateStartDate();
  }, [startDate]);

  useEffect(() => {
    updateLimitDate();
  }, [limitDate]);

  useEffect(() => {
    updateLockRow(lockedStatus);
  }, [lockedStatus]);

  const handleCheckboxChange = (e) => {
    setLockedStatus(e.target.checked);
  };

  const formatDateTimeForInputWithoutRound = (date) => {
    if (!date) return ""; // Verificar si la fecha está vacía
    const d = new Date(date); // Crear un objeto Date
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Agregar ceros si es necesario
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`; // Formato para el input datetime-local
  };

  const deliverTask = async () => {
    try {
      setIsLoading(true);
      const now = new Date();

      let mediaIds = [];
      let deliverHistoricalToSend = deliverHistorical; // Por defecto, usamos el original, si existe.

      if (task.isProofNeeded) {
        const newDeliverRegister = {
          workerNotes: workerNotes,
          deliverDate: now,
          evidenceLinks: links,
        };

        // Si deliverHistorical es undefined, inicializamos un array
        if (!Array.isArray(deliverHistorical)) {
          deliverHistoricalToSend = [];
        }

        // Agregamos el nuevo registro al array
        deliverHistoricalToSend.push(newDeliverRegister);
      }

      if (task.isProofNeeded && filesToUpload.length > 0) {
        for (const file of filesToUpload) {
          const id = await handleMediaUpload(file);
          if (id) {
            mediaIds.push(id);
          }
        }
      }

      // if (task.isVisit) {
      //   await GenerarCompraAgencia({
      //     fechaPago: now,
      //     mes: now.getMonth() + 1,
      //     año: now.getFullYear(),
      //     costoUnitario: 20,
      //     cantidad: 1,
      //     nombreItem: `Pago pasajes audiovisuales. Cliente: ${clientName || "No definido"}`,
      //   });
      // }

      const response = await axios.put(
        `${BACKEND}/api/tareasProyectos/${task.id}`,
        {
          status: "Finalizado",
          deliverDate: now,
          delivered: true,
          proofMedia: mediaIds,
          deliverHistorical: deliverHistoricalToSend, // Solo enviamos si se ha modificado o existe.
        }
      );

      if (firstMeeting) {
        ActualizarFechaInicioProyecto({ serviceId: task.serviceId });
      }

      setTaskMedia(response.data.doc.proofMedia);
      setDeliverHistorical(response.data.doc.deliverHistorical);
      if (Array.isArray(task.taskEvents) && task.taskEvents.length > 0) {
        const lastEvent = task.taskEvents[task.taskEvents.length - 1];
        if (lastEvent?.type !== "standBy") {
          await addRegisterTaskEvents(task.id);
        }
      }
      successChildUpdate();
      setStatus("Finalizado");
      setDeliverDate(now);
      setInitialLimitDate(now);
      storeTaskWorkedOnLocalStorage(task.id);
      setIsLoading(false);
    } catch (error) {
      toast.error("Error al actualizar el estado: " + error);
      setIsLoading(false);
    }
  };

  const deleteTaskFromProcess = async () => {
    const confirmed = window.confirm("Seguro desea eliminar esta tarea?");
    if (confirmed) {
      try {
        if (taskMedia && taskMedia.length > 0) {
          const deleteMediaPromises = taskMedia.map((element) =>
            axios.delete(`${BACKEND}/api/pruebasTareas/${element.id}`)
          );
          await Promise.all(deleteMediaPromises);
        }
        await axios.delete(`${BACKEND}/api/tareasProyectos/${task.id}`);
        toast.success("Tarea eliminada exitosamente");
        successChildUpdate();
      } catch (error) {
        toast.error("Error al eliminar la tarea: " + error);
      }
    }
  };

  const [audiosModal, setAudiosModal] = useState(false);
  const [linksModal, setLinksModal] = useState(false);

  const copyToClipboard = (index) => {
    const linkToCopy = task.links[index]?.link;

    if (linkToCopy) {
      navigator.clipboard
        .writeText(linkToCopy)
        .then(() => {
          toast.success("Link copiado al portapapeles");
        })
        .catch((err) => {
          toast.error("Error al copiar el link");
        });
    } else {
      console.error("No hay link para copiar en este índice:", index);
    }
  };

  const updateTask = async () => {
    try {
      // Obtener la tarea actualizada desde el backend
      const { data: updatedTask } = await axios.get(
        `${BACKEND}/api/tareasProyectos/${task.id}`
      );

      // Actualizar el estado deliverHistorical en el padre con los nuevos datos
      setDeliverHistorical(updatedTask.deliverHistorical);
    } catch (error) {
      console.error("Error al actualizar el historial de entregas: ", error);
    }
  };

  //* Guardar la tarea en el estado local
  const storeTaskWorkedOnLocalStorage = (newTaskId) => {
    // Guardar la tarea trabajada en el local storage para el reporte del día

    // Extraemos el array del local storage, si no existe lo inicializamos
    let tasksWorked = JSON.parse(localStorage.getItem("tasksWorked")) || [];

    // Verificamos si la tarea ya existe en el array
    const existingTask = tasksWorked.find(
      (existingTask) => existingTask.task === newTaskId
    );

    if (existingTask) {
      return; // Si ya existe, no hacemos nada
    }
    const newTaskWorked = { task: newTaskId }; // Creamos un objeto con la nueva tarea
    tasksWorked.push(newTaskWorked); // Agregamos la nueva tarea al array
    localStorage.setItem("tasksWorked", JSON.stringify(tasksWorked)); // Guardamos el array actualizado en el local storage
  };

  return (
    <tr
      key={task.id}
      className="bg-white text-xs text-zinc-700 whitespace-pre-line hover:bg-gray-200 transition-all duration-100"
    >
      {/* Modal para entregar pruebas */}
      <Modal
        activeModal={proofModal}
        title={`Historial de pruebas`}
        onClose={() => {
          setProofModal(false);
          setFilesToUpload([]);
          setLinks([]);
        }}
        centered={true}
      >
        <div>
          <label className="block text-gray-700 mb-4 text-xs font-bold">
            {task.name}
          </label>

          <label className="block text-gray-500 text-xs font-bold mb-4">
            Para entregar esta tarea se requieren pruebas, puedes subir hasta 5
            links de imágenes o videos
          </label>

          <div className="flex flex-col w-full mb-4 text-xs gap-2">
            <label htmlFor="bossNotes">Comentario</label>
            <input
              type="text"
              value={workerNotes}
              className="w-full border border-gray-300 rounded-lg text-xs flex items-center justify-center p-2 text-gray-700"
              onChange={(e) => setWorkerNotes(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="links" className="block mb-2 text-xs">
              Links
            </label>
            {links.map((link, index) => (
              <>
                <div
                  key={index}
                  className="flex border rounded-lg mb-3 text-xs"
                >
                  <input
                    type="text"
                    value={link.link}
                    placeholder="Ingrese un link..."
                    onChange={(event) => handleLinkChange(index, event)}
                    className="w-full border border-white rounded-l-lg px-2 py-2 text-xs"
                  />
                  <button
                    type="button"
                    onClick={() => removeLinkField(index)}
                    className="inline-flex items-center px-3 text-xs text-red-600 bg-red-100 border border-gray-300 hover:bg-red-300 rounded-r-md transition-all duration-100"
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              </>
            ))}
            {links.length < 5 && (
              <button
                type="button"
                onClick={addLinkField}
                className="w-full border text-xs border-gray-300 rounded-lg flex items-center justify-center p-2 mt-2 text-gray-700 hover:bg-blue-500 hover:bg-opacity-25 transition-all duration-100"
              >
                <FaPlus className="mr-2" /> Añadir Link
              </button>
            )}
          </div>

          <div className="flex w-full gap-4">
            <button
              type="button"
              onClick={() => {
                setProofModal(false);
                setFilesToUpload([]);
                setLinks([]);
              }}
              className="w-1/2 inline-flex items-center justify-center px-6 py-2 text-xs font-bold text-white bg-gray-500 rounded-md shadow-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-orange-400 transition-colors duration-300"
            >
              <FaTimes className="mr-2" />
              Cancelar
            </button>
            <button
              className={`w-1/2 inline-flex items-center justify-center px-6 py-2 text-xs font-bold text-white rounded-md shadow-md transition-colors duration-300 focus:outline-none focus:ring-2 ${
                filesToUpload.length === 0 && links.length === 0
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed focus:ring-gray-300"
                  : "bg-orange-500 hover:bg-orange-600 focus:ring-orange-400"
              }`}
              disabled={filesToUpload.length === 0 && links.length === 0}
              onClick={() => {
                deliverTask();
                setProofModal(false);
                setFilesToUpload([]);
                setLinks([]);
              }}
            >
              <FaCheck className="mr-2" />
              Entregar Tarea
            </button>
          </div>
        </div>
      </Modal>

      {/* Modal para ver las pruebas */}
      <Modal
        activeModal={watchMediaModal}
        title={"Pruebas"}
        onClose={() => {
          setWatchMediaModal(false);
        }}
        centered={true}
      >
        <div className="flex flex-col mb-4 gap-2 w-full">
          <h2 className="text-xs text-gray-600 font-bold">{task.name}</h2>
          <div className="flex flex-row w-full justify-between items-center px-4 py-2 rounded-md border border-gray-200">
            <p className="text-xs text-gray-600 font-bold">
              Responsable: {task.responsible?.name} - {task.responsible?.puesto}
            </p>
            <img
              src={task.responsible?.foto?.url}
              alt={task.responsible?.name}
              className="w-10 h-10 rounded-full"
            />
          </div>

          <p className="text-xs text-gray-600 mt-2 font-bold">
            Historial de entregas:{" "}
          </p>

          <div className="flex flex-col gap-4 max-h-[500px] overflow-y-auto">
            {deliverHistorical
              ?.slice()
              .reverse()
              .map((register) => (
                <RegisterDeliverCard
                  key={register.id}
                  updateStatusFromChild={updateStatusFromChild}
                  updateTask={updateTask}
                  register={register}
                  taskId={task.id}
                  userStatus={userStatus}
                  successChildUpdate={successChildUpdate}
                />
              ))}
          </div>
        </div>
      </Modal>

      {/* Modal de links */}
      <Modal
        activeModal={linksModal}
        title={`Links: ${task.name}`}
        onClose={() => setLinksModal(false)}
        centered={true}
      >
        {/* Mostrar los links subidos */}
        {task.links?.length > 0 ? (
          <ul className="list-disc">
            {task.links.map((link, index) => (
              <div key={index} className="flex border rounded-lg mb-3">
                <button
                  type="button"
                  onClick={() => copyToClipboard(index)}
                  className="inline-flex items-center px-3 text-xs text-green-600 bg-green-100 border border-gray-100 hover:bg-green-200 transition-all duration-100  rounded-l-md"
                >
                  <FaLink />
                </button>
                <input
                  type="text"
                  value={link.link}
                  placeholder="Ingrese un link..."
                  //onChange={(event) => handleLinkChange(index, event)}
                  className="flex w-full justify-center text-xs items-center border border-gray-100 rounded-r-md px-2 py-2"
                />
              </div>
            ))}
          </ul>
        ) : (
          <div className="flex justify-center items-center h-[50px] border text-xs font-bold rounded-md">
            No hay links subidos
          </div>
        )}

        {/* Sección para subir nuevos links */}
        {/* <div className="mt-4">
                    {task.links.length < 5 ? (
                        <button
                            onClick={addNewLink}  // Función para subir un nuevo link
                            className="flex w-full justify-center items-center gap-2 bg-white hover:bg-blue-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
                        >
                            <span className="text-blue-700">Crear nuevo link</span>
                            <FaPlus className="text-blue-700"/>
                        </button>
                    ) : (
                        <div className="flex w-full justify-center items-center text-red-500">
                            Ya has subido el máximo de 5 links
                        </div>
                    )}
                </div> */}
      </Modal>

      {/* Modal de audios */}
      <Modal
        activeModal={audiosModal}
        title={`Audios: ${task.name}`}
        onClose={() => setAudiosModal(false)}
        centered={true}
      >
        {task.audios?.length > 0 ? (
          <ul className="list-disc">
            {task.audios?.map((audio, index) => {
              const id = audio.id;
              const url = audio.url;
              const name = audio.filename;
              const mymeType = audio.mimeType;
              const fileType = audio.mimeType?.split("/")[0];

              return (
                <div
                  key={index}
                  className="border p-3 w-full rounded-md shadow hover:bg-gray-50 transition-all duration-100 mb-4"
                >
                  <div>
                    {fileType === "video" && (
                      <div className="items-centerspace-y-6">
                        <div className="flex items-center justify-between">
                          <span className="mb-2">{name}</span>
                          <div className="flex space-x-2">
                            <button
                              type="button"
                              onClick={() => window.open(url, "_blank")}
                              className="p-2 text-blue-500 text-xs hover:bg-blue-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-blue-700 bg-opacity-10 flex items-center"
                            >
                              <FaExternalLinkAlt />
                            </button>
                          </div>
                        </div>
                        <video controls className="w-full h-auto rounded">
                          <source src={url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    )}

                    {fileType === "audio" && (
                      <div className="items-center justify-center space-y-6">
                        <div className="flex items-center justify-between">
                          <span className="mb-2">{name}</span>
                          <div className="flex space-x-2">
                            <button
                              type="button"
                              onClick={() => window.open(url, "_blank")}
                              className="p-2 text-blue-500 text-xs hover:bg-blue-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-blue-700 bg-opacity-10 flex items-center"
                            >
                              <FaExternalLinkAlt />
                            </button>
                            {/* <button
                                                            type="button"
                                                            onClick={() => deleteAudio(id)}
                                                            className="p-2 text-red-500 hover:bg-red-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-red-700 bg-opacity-10 flex items-center"
                                                        >
                                                            <FaTrash />
                                                        </button> */}
                          </div>
                        </div>
                        <audio controls className="w-full max-h-12">
                          <source src={url} type={mymeType} />
                          Your browser does not support the audio element.
                        </audio>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </ul>
        ) : (
          <div className="flex justify-center text-xs font-bold items-center h-[50px] border rounded-md">
            No hay audios subidos
          </div>
        )}

        {/* <div className="mt-4">
                    {audios.length < 5 ? (
                        <button
                            onClick={isRecording ? stopRecording : startRecording}
                            className={`flex w-full justify-center items-center gap-2 transition-all duration-100 text-white px-4 py-2 rounded-lg 
                            ${isRecording ? 'bg-red-500 hover:bg-red-600' : 'bg-white hover:bg-green-200'}`}
                        >
                            {isRecording ? (
                                <>
                                    <span className="text-white">Detener grabación</span>
                                    <FaStop className="text-white" />
                                </>
                            ) : (
                                <>
                                    <span className="text-green-700">Grabar nuevo audio</span>
                                    <FaMicrophone className="text-green-700" />
                                </>
                            )}
                        </button>
                    ) : (
                        <div className="flex w-full justify-center items-center text-red-500">
                            Ya has subido el máximo de 5 audios
                        </div>
                    )}
                </div> */}
      </Modal>

      <td className="py-2 border px-4 text-center">
        {task.label}
      </td>

      <td className="p-2 border w-1/4">
        {task.isVisit && <FaVideo className="text-green-500" />}{" "}
        {task.isMeeting && <SiGooglemeet className="text-blue-500" />}{" "}
        {task.name || task.task.name}
      </td>

      <td className="border">
        <select
          value={responsible ? responsible.id : ""}
          onChange={(e) => {
            const selectedTrabajador = trabajadores.find(
              (t) => t.id === e.target.value
            );
            setResponsible(selectedTrabajador || null); // Si no hay trabajador, establece como null
          }}
          className="w-full border-white rounded-md text-xs"
          disabled={!(userStatus === "SuperAdmin") || lockedStatus}
        >
          <option key={""} value={""} className="text-black">
            Seleccionar trabajador
          </option>
          {trabajadores.map((trabajador) => (
            <option
              key={trabajador.id}
              value={trabajador.id}
              className="text-black"
            >
              {trabajador.name + " - " + trabajador.puesto}
            </option>
          ))}
        </select>
      </td>

      <td className="border px-1">
        <label className="flex items-center justify-center">
          <button
            onClick={() => {
              addRegisterTaskEvents(task.id);
              storeTaskWorkedOnLocalStorage(task.id);

              // Simula el próximo estado de los eventos
              const lastEventType =
                task.taskEvents?.[task.taskEvents.length - 1]?.type;
              const nextStatus =
                lastEventType === "standBy" || !lastEventType
                  ? "En proceso"
                  : "Pendiente";

              setStatus(nextStatus);
            }}
            disabled={
              !(
                task?.responsible?.id === user?.id ||
                userStatus === "SuperAdmin"
              ) ||
              lockedStatus ||
              task.delivered !== false
            }
            className={`p-2 rounded-md transition-colors shadow-md duration-100 ${
              !(
                task?.responsible?.id === user?.id ||
                userStatus === "SuperAdmin"
              ) ||
              lockedStatus ||
              task.delivered !== false
                ? "bg-gray-300 text-gray-600 cursor-not-allowed" // Estilo deshabilitado
                : "bg-gray-100 text-white hover:bg-gray-300" // Estilo habilitado
            }`}
          >
            {!(
              task?.responsible?.id === user?.id || userStatus === "SuperAdmin"
            ) ||
            lockedStatus ||
            task.delivered !== false ? (
              // Tooltip para estado deshabilitado
              <Tooltip content="No puedes interactuar con esta tarea">
                <div>
                  <FaBan className="text-gray-500" />
                </div>
              </Tooltip>
            ) : task.taskEvents &&
              task.taskEvents.length > 0 &&
              task.taskEvents[task.taskEvents.length - 1].type !== "standBy" ? (
              // Tooltip para tarea en pausa
              <Tooltip content="Tarea en progreso, haz click para pausar">
                <div>
                  <FaPause className="text-red-500" />
                </div>
              </Tooltip>
            ) : (
              // Tooltip para tarea en progreso
              <Tooltip content="Tarea en pausa, haz click para reanudar">
                <div>
                  <FaPlay className="text-green-500" />
                </div>
              </Tooltip>
            )}
          </button>
        </label>
      </td>

      {/* <td>
                {task.taskEvents?.[task.taskEvents.length - 1].type}
            </td> */}

      <td
        className={`border ${
          status === "Pendiente"
            ? "text-yellow-500"
            : status === "En proceso"
            ? "text-blue-500"
            : status === "Finalizado"
            ? "text-green-500"
            : status === "Declinado"
            ? "text-orange-500"
            : status === "Con retraso"
            ? "text-purple-500"
            : status === "Incumplido"
            ? "text-red-500"
            : status === "Eliminado"
            ? "text-black"
            : ""
        }`}
      >
        <select
          value={status}
          onChange={(e) => {
            setStatus(e.target.value);
            storeTaskWorkedOnLocalStorage(task.id);
            //addRegisterTaskEvents(task.id)
          }}
          className="w-full border-white rounded-md text-xs"
          // Deshabilitar para usuarios no SuperAdmin si la tarea ha sido entregada
          disabled={true}
        >
          {/* Opciones para SuperAdmin: puede ver y modificar todo */}
          {userStatus === "SuperAdmin" && (
            <>
              <option value="Pendiente" className="text-yellow-500">
                Pendiente
              </option>
              <option value="En proceso" className="text-blue-500">
                En proceso
              </option>
              <option value="Finalizado" className="text-green-500">
                Finalizado
              </option>
              <option value="Declinado" className="text-orange-500">
                Declinado
              </option>
              <option value="Con retraso" className="text-purple-500">
                Con retraso
              </option>
              <option value="Incumplido" className="text-red-500">
                Incumplido
              </option>
              <option value="Eliminado" className="text-black">
                Eliminado
              </option>
            </>
          )}

          {/* Opciones para usuarios no SuperAdmin si la tarea NO ha sido entregada */}
          {userStatus !== "SuperAdmin" && !task.delivered && (
            <>
              <option value="Pendiente" className="text-yellow-500">
                Pendiente
              </option>
              <option value="Declinado" className="text-orange-500">
                Declinado
              </option>
              <option value="En proceso" className="text-blue-500">
                En proceso
              </option>
            </>
          )}

          {/* Opciones para usuarios no SuperAdmin si la tarea HA sido entregada (bloqueadas) */}
          {userStatus !== "SuperAdmin" && task.delivered && (
            <>
              <option value="Pendiente" className="text-yellow-500">
                Pendiente
              </option>
              <option value="En proceso" className="text-blue-500">
                En proceso
              </option>
              <option value="Finalizado" className="text-green-500">
                Finalizado
              </option>
              <option value="Declinado" className="text-orange-500">
                Declinado
              </option>
              <option value="Con retraso" className="text-purple-500">
                Con retraso
              </option>
              <option value="Incumplido" className="text-red-500">
                Incumplido
              </option>
              <option value="Eliminado" className="text-black">
                Eliminado
              </option>
            </>
          )}
        </select>
      </td>

      <td className="border justify-center px-1">
        <button
          className={`flex inline-flex w-full justify-center text-xs items-center px-2 py-2 text-sm font-semibold rounded-md transition-colors duration-100
                        ${
                          !(
                            task?.responsible?.id === user?.id ||
                            userStatus === "SuperAdmin"
                          ) ||
                          lockedStatus ||
                          task.delivered != false
                            ? "bg-gray-500 text-gray-300 cursor-not-allowed"
                            : "bg-orange-500 text-white hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400"
                        }`}
          onClick={() => {
            if (
              (task?.responsible?.id === user?.id ||
                userStatus === "SuperAdmin") &&
              !lockedStatus
            ) {
              // Si la tarea requiere pruebas, se abre el modal para que el usuario pueda subirlas
              if (task.isProofNeeded) {
                setProofModal(true); // Abre el modal si se necesita prueba
              } else {
                deliverTask(); // Entrega la tarea si no se necesita prueba
              }
            }
          }}
          disabled={
            !(
              task?.responsible?.id === user?.id || userStatus === "SuperAdmin"
            ) ||
            lockedStatus ||
            task.delivered !== false
          }
        >
          {isLoading ? (
            <FaSpinner className="animate-spin text-white" />
          ) : task.delivered ? (
            task.isVisit ? (
              "Programada"
            ) : (
              "Entregado"
            )
          ) : (
            task.isVisit ? (
              "Programar"
            ) : (
              "Entregar"
            )
          )}
        </button>
      </td>

      <td className="border">
        <input
          type="datetime-local"
          id="deliverDate"
          name="deliverDate"
          value={formatDateTimeForInputWithoutRound(deliverDate)}
          onChange={(e) => setDeliverDate(e.target.value)}
          className="bg-white border border-white text-xs rounded-md shadow-sm focus:outline-none focus:ring-white transition duration-150 ease-in-out"
          //disabled
          disabled={!(userStatus === "SuperAdmin") || lockedStatus}
          //disabled={!(task?.responsible?.id === user?.id || userStatus === "Admin" || userStatus === "SuperAdmin") || lockedStatus}
        />
      </td>

      <td className="border px-1">
        {deliverHistorical?.length > 0 ? (
          <label className="flex items-center justify-center hover:cursor-pointer">
            <button
              disabled={lockedStatus}
              onClick={() => {
                setWatchMediaModal(true);
              }}
            >
              <div
                className={`flex items-center justify-center px-2 py-2 rounded-lg transition-colors duration-300 bg-blue-600 text-white hover:bg-blue-700`}
              >
                <FaEye />
              </div>
            </button>
          </label>
        ) : (
          <label className="flex items-center justify-center">
            <div
              className={`flex items-center justify-center px-2 py-2 rounded-lg bg-gray-300 text-white
                            ${
                              lockedStatus
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`} // Estilo para deshabilitado
            >
              <FaEyeSlash />
            </div>
          </label>
        )}
      </td>

      <td className="border px-1">
        {task.links?.length > 0 ? (
          <div className="flex items-center justify-center">
            <button
              className={`flex items-center justify-center px-2 py-2 hover:cursor-pointer rounded-lg bg-blue-500 transition-colors duration-300 text-white hover:bg-blue-700`}
              onClick={() => setLinksModal(true)} // Función para manejar la acción del botón
            >
              <FaLink className="text-white" />
            </button>
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <button
              className={`flex items-center justify-center px-2 py-2 rounded-lg transition-colors duration-300 bg-gray-300 text-white`}
              disabled
            >
              <FaLink className="text-white" />
            </button>
          </div>
        )}
      </td>

      <td className="border px-1">
        {task.audios?.length > 0 ? (
          <div className="flex items-center justify-center">
            <button
              className={`flex items-center justify-center px-2 py-2 rounded-lg bg-green-500 transition-colors duration-300 text-white hover:bg-green-700 hover:cursor-pointer`}
              onClick={() => setAudiosModal(true)} // Función para manejar la acción del botón
            >
              <FaPlay className="text-white" />
            </button>
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <button
              className={`flex items-center justify-center px-2 py-2 rounded-lg transition-colors duration-300 bg-gray-300 text-white`}
              disabled
            >
              <FaPlay className="text-white" />
            </button>
          </div>
        )}
      </td>

      <td className="border px-1">
        <label className="flex items-center hover:cursor-pointer">
          <input
            type="checkbox"
            checked={lockedStatus}
            onChange={handleCheckboxChange}
            disabled={userStatus !== "SuperAdmin"}
            className="hidden"
          />
          <div
            className={`flex items-center justify-center px-2 py-2 rounded-lg transition-colors duration-300 mx-auto 
                        ${
                          lockedStatus
                            ? "bg-red-600 text-white hover:bg-red-700"
                            : "bg-green-600 text-white hover:bg-green-700"
                        } 
                        ${
                          userStatus !== "SuperAdmin"
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`} // Estilo para deshabilitado
          >
            {lockedStatus ? <FaLock /> : <FaLockOpen />}
          </div>
        </label>
      </td>

      <td className="py-2 border px-2 text-center">{task.score}</td>

      <td className="py-2 border px-2 text-center">
        {task.defaultScoreAssignedTo?.name
          ? task.defaultScoreAssignedTo?.name
          : "-"}
      </td>

      {userStatus === "SuperAdmin" && (
        <td className="border px-2">
          <label className="flex items-center justify-center cursor-pointer">
            <button
              //disabled={lockedStatus} // Similar a la lógica del checkbox
              onClick={deleteTaskFromProcess}
            >
              <div
                className={`flex items-center justify-center px-2 py-2 rounded-lg transition-colors duration-300 bg-red-600 text-white hover:bg-red-700`}
                style={{ width: "32px", height: "32px" }}
              >
                <FaTrash />
              </div>
            </button>
          </label>
        </td>
      )}
    </tr>
  );
};

export default ItemRowTareaProyecto;
